import TablePageTreeBase from './tablePageTreeBase.vue';

export default TablePageTreeBase;
